import { RectSize } from "./RectSize";

/**
 * Viewport size corresponds to device physical size
 * - is a virtual size that doesnt take device's DPR into account
 * - to get 1:1 pixel size, @see GetWindowSize
 * @returns 
 */
export function GetViewportSize(): RectSize
{
    let width: number, height: number;

    if (document.documentElement && ("clientWidth" in document.documentElement)) {
        width = document.documentElement.clientWidth;
        height = document.documentElement.clientHeight;
    }
    else {
        width = window.innerWidth,
        height = window.innerHeight;
    }

    return new RectSize(width, height);
}